var __jsx = React.createElement;
import React from 'react';
import Countdown from 'react-countdown';
import { Icon } from "@syarahtech/ui";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useTranslation } from '@i18n';
var PromoButton = function PromoButton(_ref) {
  var promoCode = _ref.promoCode,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var lang = useLang();
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var handleClick = function handleClick() {
    // The onClick from GlobalPromoManager will handle tracking and redirect
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  return /*#__PURE__*/React.createElement(Countdown, {
    date: promoCode.expires_at,
    daysInHours: true,
    renderer: function renderer(_ref2) {
      var days = _ref2.days,
        hours = _ref2.hours,
        minutes = _ref2.minutes,
        seconds = _ref2.seconds,
        completed = _ref2.completed;
      if (completed) {
        return null; // Don't render if expired
      }
      var formattedTime = "".concat(String(hours + days * 24), ":").concat(String(minutes), ":").concat(String(seconds));
      return /*#__PURE__*/React.createElement("div", {
        className: "fixed text-center items-center md:bottom-8 bottom-16 z-[999999] left-1/2 transform -translate-x-1/2 w-[290px] en:w-[320px]"
      }, /*#__PURE__*/React.createElement("button", {
        onClick: handleClick,
        className: "w-full text-center justify-center \n                border-0\n                  bg-[#fe561c] \n                  text-white font-bold py-2 px-4 rounded-md\n                  flex items-center gap-2 text-xss\n                  ar:flex-row en:flex-row-reverse\n                  ar:text-right en:text-left\n                  ".concat(className, "\n                   cursor-pointer\n                "),
        dir: lang === 'ar' ? 'rtl' : 'ltr'
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "material-symbols--acute-outline-rounded en:order-last",
        className: "text-white w-4.5 h-2.5  en:scale-x-[-1]"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-xs "
      }, tShort("promo/time_remaining_for_discount", {
        ns: "web_promo"
      }), " ", formattedTime), /*#__PURE__*/React.createElement(Icon, {
        className: "w-4.5 h-2.5 ar:-rotate-90 en:rotate-90 text-white en:order-first",
        icon: "material-symbols--keyboard-arrow-up-rounded"
      })));
    }
  });
};
export default PromoButton;